// Venue-specific additions to the concessions views, kept out of the vertical itself.
// Key: `${venue}:${locationId}` (location ids are only unique within a venue).
// Each entry fills named slots in the standard views (see Slot.js); a stand with no entry renders
// exactly as before. The custom code lives with the team, under src/venues/<league>/<team>/, and is
// loaded only when that stand is opened.
//
// Slots so far:
//   gameDay.kpis  extra cards at the end of the KPI row, live and past Game Day
//                 (props: authCtx, currentLocation, currentGame, selectedDate, isLive, refreshKey)
//   overview.sectionCard  extra content in each Overview section card, above its footer
//                 (props: authCtx, currentLocation, sectionId, games: [{ date, color, ... }] with data
//                  for that section)
import { lazy } from 'react';

export const CONCESSION_EXTENSIONS = {
  // Titans · Nashgrille To Go (stand 2): register usage split for section 117
  'titansNFL:2': {
    slots: {
      'gameDay.kpis': lazy(() => import('../../../venues/nfl/titans/concessions/RegisterSplitCard')),
      'overview.sectionCard': lazy(() => import('../../../venues/nfl/titans/concessions/SectionRegisterSplit')),
    },
  },
};
